import React from 'react';
import SMReservationCalendarDesktopView from './SMReservationCalendarDesktopView';
import SMStayReservationCalendarDesktopView from './SMStayReservationCalendarDesktopView';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SMPlanHelper from 'components/helpers/SMPlanHelper';
import SMConst from 'lib/SMConst';
import sprintf from 'sprintf';
import SMReservationCalendarView from './SMReservationCalendarView';
import SMStayReservationCalendarView from './SMStayReservationCalendarView';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import FastClick from 'fastclick';
import SMRoomResource from 'resources/SMRoomResource';

class SMAppReservationView extends React.Component {

  constructor(props) {
    super(props);
    const date = new Date();

    // default plan
    const plan = this.props.room.plans.length == 0 ? this.props.room : null;
    let isHourly = null;
    this.resetReservation();
    if (plan) {
      this.requestParams.plan_id = SMPlanHelper.isRoom(plan) ? 0 : plan.id;
      isHourly = this.getIsHourly(plan);
      this.requestParams.is_hourly = isHourly;
    }

    this.state = {
      room: this.props.room,
      plan: plan,
      display: SMConst.Display.Visible,
      rentType: SMConst.RentType.DayTime,
      isHourly: isHourly,
      priceText: "",
      priceExtraText: "",
      reservedDateText: I18n.t("service.label_000050"),
      validatedReservation: null,
      isValid: false,
      errors: [],
      numberOfGuests: 1,
      optionItems: {},
      optionFoods: {},
      isRequestViewOpen: false,
      isContactViewOpen: false,
    };
    this.appBridge = null;
  }

  isStayPlan() {
    return this.state.plan.rent_type == SMConst.RentType.Stay;
  }

  isDayTimePlan() {
    return this.state.plan.rent_type == SMConst.RentType.DayTime;
  }

  isPerPersonPlan() {
    return this.state.plan.price_calc_type == SMConst.PriceCalcType.PerPerson;
  }

  getIsHourly(plan) {
    let isHourly = null;
    if (plan.has_session_price) {
      isHourly = plan.min_required_session_hour_unit == SMConst.RequiredUnit.Hour ? 1 : 0;
    }
    else if (!(plan.has_daily_price && plan.has_hourly_price)) {
      isHourly = plan.has_hourly_price ? 1 : 0;
    }
    else if (plan.has_stay_price) {
      isHourly = 0;
    }

    return isHourly;
  }

  resetReservation() {
    this.requestParams = {
      isValid: false,
      is_hourly: null,
      plan_id: null,
      reserved_schedules: [],
      reserved_option_items: [],
      reserved_option_foods: [],
      card_type: null,
      token: null,
      dryrun: this.props.currentUser ? false : true,
    };

    this.setState({
      validatedReservation: null,
      isValid: false,
      isRequestViewOpen: false,
      isContactViewOpen: false,
      priceText: "",
      priceExtraText: "",
      reservedDateText: I18n.t("service.label_000050"),
      numberOfGuests: 1,
      optionItems: {},
      optionFoods: {},
    });
  }

  componentDidMount() {
    FastClick.attach(document.body);
    document.addEventListener('WebViewJavascriptBridgeReady', (event)=> {
      this.appBridge = event.bridge;
      this.appBridge.init(function(data){
        SpaceMarket.Session.AccessToken = data.access_token;
      });
    }, false);

    if (!SMAppHelper.isMobile()) {
      $(this.refs.spaceSide).sticky({
        topSpacing:32,
        bottomSpacing:$("#js-site-footer").outerHeight() + 24
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
  }

  planDidSelect(index, e) {
    this.resetReservation();
    const plan = [this.state.room].concat(this.state.room.plans)[index];
    this.requestParams.plan_id = SMPlanHelper.isRoom(plan) ? 0 : plan.id;
    const isHourly = this.getIsHourly(plan);
    this.requestParams.is_hourly = isHourly;
    this.setState({
      plan: plan,
      rentType: plan.rent_type,
      isHourly: isHourly,
      priceText: "",
      priceExtraText: "",
      reservedDateText: I18n.t("service.label_000050"),
    });
    setTimeout(()=>{
      $("body").animate({scrollTop: $(this.refs.priceTypeContainer).offset().top}, 500);
    }, 500);
  }

  priceTypeDidSelect(e) {
    const isHourly = e.currentTarget.value;
    this.requestParams.is_hourly = isHourly;
    this.requestParams.reserved_schedules = [];
    this.setState({
      isValid: false,
      isHourly: isHourly,
      rentType : this.state.plan.rent_type,
    });
  }

  checkinAtDidSelect(e) {
    const selectedTimeString = e.currentTarget.value;
    const checkinAtHour = parseInt(selectedTimeString.substr(0,2));
    const checkinAtMinute = parseInt(selectedTimeString.substr(3,2));

    const date = new Date(this.requestParams.reserved_schedules[0]["started_at"]);
    const newCheckInDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), checkinAtHour, checkinAtMinute));
    this.requestParams.stay_checkin_at = this.requestParams.reserved_schedules[0]["started_at"] = newCheckInDate.toISOString();

    const checkinAt = Date.parse(newCheckInDate.toISOString());
    const checkoutAt = Date.parse(this.requestParams.stay_checkout_at);
    const duration = (checkoutAt - checkinAt) / (1000 * 60);

    this.requestParams.reserved_schedules[0]["duration"] = duration;

    this.validateReservation();
  }

  optionItemDidSelect(index, e) {
    const $el = $(e.currentTarget);
    const optionItem = this.state.room.option_items[index];
    const selectedIndex = this.getSelectedIndexForOptionItems(optionItem, this.requestParams.reserved_option_items);

    if (selectedIndex != null) {
      this.requestParams.reserved_option_items.splice(selectedIndex, 1);
      this.state.optionItems[optionItem.id].checked = false;
    } else {
      this.requestParams.reserved_option_items.push({
        option_item_id: optionItem.id,
        number: this.state.optionItems[optionItem.id].value,
      });
      this.state.optionItems[optionItem.id].checked = true;
    }
    const items = this.state.optionItems;
    this.setState({ optionItems: items });

    this.validateReservation();
  }

  optionItemsMinusButtonClick(id, index, e) {
    e.preventDefault();
    let cnt = this.state.optionItems[id].value;
    if (cnt <= 1) {
      return false;
    }
    cnt -= 1;
    this.state.optionItems[id].value = cnt;
    const items = this.state.optionItems;
    this.setState({
      optionItems: items
    });

    const selectedIndex = this.getSelectedIndexForOptionItems(this.state.room.option_items[index], this.requestParams.reserved_option_items);
    if (this.requestParams.reserved_option_items[selectedIndex]) {
      this.requestParams.reserved_option_items[selectedIndex]['number'] = cnt;
      this.validateReservation();
    }
  }

  optionItemsPlusButtonClick(id, item, index, e) {
    e.preventDefault();
    let cnt = this.state.optionItems[id].value;
    let max_cnt = item.max_count ? item.max_count : null;
    if (max_cnt && cnt >= max_cnt) {
      return false;
    }
    cnt += 1;
    this.state.optionItems[id].value = cnt;
    const items = this.state.optionItems;
    this.setState({
      optionItems: items
    });

    const selectedIndex = this.getSelectedIndexForOptionItems(this.state.room.option_items[index], this.requestParams.reserved_option_items);
    if (this.requestParams.reserved_option_items[selectedIndex]) {
      this.requestParams.reserved_option_items[selectedIndex]['number'] = cnt;
      this.validateReservation();
    }
  }

  getSelectedIndexForOptionItems(optionItem, reservedOptionItems) {
    let selectedIndex = null;
    reservedOptionItems.some((item, index)=>{
      if (item.option_item_id === optionItem.id) {
        selectedIndex = index;
        return true;
      }
    });
    return selectedIndex;
  }

  optionFoodDidSelect(index, e) {
    const $el = $(e.currentTarget);
    const optionFood = this.state.room.option_foods[index];

    const selectedIndex = this.getSelectedIndexForOptionFoods(optionFood, this.requestParams.reserved_option_foods);
    if (selectedIndex != null) {
      this.requestParams.reserved_option_foods.splice(selectedIndex, 1);
      this.state.optionFoods[optionFood.id].checked = false;
    } else {
      this.requestParams.reserved_option_foods.push({
        option_food_id: optionFood.id,
        number: this.state.optionFoods[optionFood.id].value,
      });
      this.state.optionFoods[optionFood.id].checked = true;
    }
    const foods = this.state.optionFoods;
    this.setState({ optionFoods: foods });

    this.validateReservation();
  }

  optionFoodsMinusButtonClick(id, index, e) {
    e.preventDefault();
    let cnt = this.state.optionFoods[id].value;
    if (cnt <= 1) {
      return false;
    }
    cnt -= 1;
    this.state.optionFoods[id].value = cnt;
    const foods = this.state.optionFoods;
    this.setState({
      optionFoods: foods
    });

    const selectedIndex = this.getSelectedIndexForOptionFoods(this.state.room.option_foods[index], this.requestParams.reserved_option_foods);
    if (this.requestParams.reserved_option_foods[selectedIndex]) {
      this.requestParams.reserved_option_foods[selectedIndex]['number'] = cnt;
      this.validateReservation();
    }
  }

  optionFoodsPlusButtonClick(id, item, index, e) {
    e.preventDefault();
    let cnt = this.state.optionFoods[id].value;
    let max_cnt = item.max_count ? item.max_count : null;
    if (max_cnt && cnt >= max_cnt) {
      return false;
    }
    cnt += 1;
    this.state.optionFoods[id].value = cnt;
    const foods = this.state.optionFoods;
    this.setState({
      optionFoods: foods
    });

    const selectedIndex = this.getSelectedIndexForOptionFoods(this.state.room.option_foods[index], this.requestParams.reserved_option_foods);
    if (this.requestParams.reserved_option_foods[selectedIndex]) {
      this.requestParams.reserved_option_foods[selectedIndex]['number'] = cnt;
      this.validateReservation();
    }
  }

  getSelectedIndexForOptionFoods(optionFood, reservedOptionFoods) {
    let selectedIndex = null;
    reservedOptionFoods.some((item, index)=>{
      if (item.option_food_id === optionFood.id) {
        selectedIndex = index;
        return true;
      }
    });
    return selectedIndex;
  }

  stayScheduleDidSelect(selectedAt, duration, isCheckinCalendar, checkinEnable) {
    if (isCheckinCalendar) {
      const reservedSchedules = this.requestParams.reserved_schedules ? this.requestParams.reserved_schedules : null;
      if (reservedSchedules && reservedSchedules.length > 0) {
        this.setState({
          validatedReservation : null,
          priceText: "",
          priceExtraText: ""
        });
        this.requestParams.reserved_schedules.map(function(schedule){
          schedule['started_at'] = selectedAt.toISOString();
          schedule['duration'] = duration;
        });
      } else {
        this.requestParams.reserved_schedules.push({
          started_at: selectedAt.toISOString(),
          is_stay_start: 1,
          duration: duration
        });
      }
      this.requestParams.stay_checkin_at = selectedAt.toISOString();
      this.setState({checkinEnable: checkinEnable});
    } else {
      this.requestParams.number_of_guests = 1;
      this.requestParams.number_of_stays = 1;
      this.requestParams.stay_checkout_at = selectedAt.toISOString();
      this.requestParams.reserved_schedules[0]["duration"] = duration;
    }
  }

  scheduleDidSelect(startedAt, duration, isSessionStart) {
    const str = startedAt.toISOString();
    let selectedIndex = null;
    let isPrevent = false;
    this.requestParams.reserved_schedules.some((schedule, index)=>{
      if (this.state.plan.has_session_price) {
        for (var i = 0; i < schedule.duration; i += 60) {
          let date = new Date(schedule.started_at);
          date.setUTCHours(date.getUTCHours() + i / 60);
          if (str == date.toISOString()) {
            if (i == 0) {
              selectedIndex = index;
            } else {
              isPrevent = true;
            }
            return true;
          }
        }
      } else {
        if (schedule.started_at == str) {
          selectedIndex = index;
          return true;
        }
      }
    });
    if (isPrevent) {
      return;
    }
    if (selectedIndex != null) {
      this.requestParams.reserved_schedules.splice(selectedIndex, 1);
    } else {
      this.requestParams.reserved_schedules.push({
        started_at: startedAt.toISOString(),
        is_session_start: isSessionStart ? 1 : 0,
        duration: duration,
      });
    }
    if (this.isPerPersonPlan()){
      if (!this.requestParams.number_of_guests) {
        this.requestParams.number_of_guests = 1;
      }
    }
    this.validateReservation();
  }

  renderPlans(room) {
    let rows = [];
    let roomPlans = [this.state.room].concat(room.plans);

    roomPlans.forEach((plan, index)=>{
      const name = plan.plan_name || plan.name;
      const description = (index == 0) ? plan.plan_description : plan.description;
      const id = sprintf("plan-radio__%s", plan.id);

      let prices = [];
      if (plan.has_session_price) {
        const key = "session_price_" + plan.id.toString();
        prices.push(
          <div key={key} ><span className="reserve-plan__price-number">{plan.session_price_text}<span className="reserve-plan__price-utility">/{plan.session_price_unit_text}〜</span></span></div>
        );
      }
      if (plan.has_hourly_price) {
        const key = "hourly_price_" + plan.id.toString();
        prices.push(
          <div key={key} ><span className="reserve-plan__price-number">{plan.hourly_price_text}<span className="reserve-plan__price-utility">/{plan.hourly_price_unit_text}〜</span></span></div>
        );
      }
      if (plan.has_daily_price) {
        const key = "daily_price_" + plan.id.toString();
        prices.push(
          <div key={key} ><span className="reserve-plan__price-number">{plan.daily_price_text}<span className="reserve-plan__price-utility">/{plan.daily_price_unit_text}〜</span></span></div>
        );
      }
      if (plan.has_stay_price) {
        const key = "stay_price_" + plan.id.toString();
        prices.push(
          <div key={key} ><span className="reserve-plan__price-number">{plan.stay_price_text}<span className="reserve-plan__price-utility">/{plan.stay_price_unit_text}〜</span></span></div>
        );
      }

      const isChecked = this.state.plan && plan.id == this.state.plan.id;

      rows.push(
        <div key={plan.id} className="reserve-card__inner reserve-plan__content clearfix">
          <input onChange={this.planDidSelect.bind(this, index)} type="radio" defaultChecked={isChecked} value={plan.id} id={id} name="plan_radio" />
          <label htmlFor={id} className="service-radio">
            <span className="reserve-plan__title">{name}</span>
            {prices}
            {SMRenderHelper.renderDirectReservationIcon(plan)}
            {SMRenderHelper.renderLastMinuteDiscountIcon(plan)}
            <span className="reserve-plan__notes">
              <span className="reserve-plan__notes-text">{description}</span>
              {(()=>{
                if (plan.rent_type != SMConst.RentType.DayTime) return null;
                return <span className="reserve-plan__notes-time">このプランの貸し出し時間：{room.business_hours_text} </span>;
              })()}
            </span>
          </label>
        </div>
      );
    });

    return (
      <div className="reserve-card sm-hide__guteter">
        {rows}
      </div>
    );
  }

  renderOptionItems(room) {
    let rows = [];
    room.option_items.forEach((item, index)=>{
      const id = sprintf("reserve-option-item__checkbox-%s", item.id);
      const style = !item.countable || item.max_count == 1 ? {display: "none"} : {};
      if (!this.state.optionItems[item.id]) {
        this.state.optionItems[item.id] = {};
        this.state.optionItems[item.id].checked = false;
        this.state.optionItems[item.id].value = 1;
      }
      const amount = this.state.optionItems[item.id].value;
      const checked = this.state.optionItems[item.id].checked;
      const plusClass = item.max_count && amount >= item.max_count ? "plus-disabled" : "plus";
      const minusClass = amount > 1 ? "minus" : "minus-disabled";

      rows.push(
        <div key={item.id} className="reserve-card__inner clearfix">
          <div className="reserve-option__content">
            <div style={style} className="reserve-option__number">
              <div className="reserve-stay__line-innner-form">
                <p className="reserve-amount">
                  <span className="reserve-amount__number" data-index={index} id={"items__" + id + "__number"}>{amount}</span>
                  <span className="reserve-amount__number-minus"><a onClick={this.optionItemsMinusButtonClick.bind(this, item.id, index)} href="#" className={minusClass}>削除</a></span>
                  <span className="reserve-amount__number-plus"><a onClick={this.optionItemsPlusButtonClick.bind(this, item.id, item, index)} href="#" className={plusClass}>追加</a></span>
                </p>
              </div>
            </div>
            <div className="reserve-option__content-headline">
              <input checked={checked} onChange={this.optionItemDidSelect.bind(this, index)} type="checkbox" id={id} defaultChecked={false} />
              <label htmlFor={id} className="service-checkbox">
                <span className="reserve-option__name">{item.name}</span><span className="reserve-option__price">{item.price_text}<span className="reserve-option__price-number">/{item.price_unit_text}</span></span>
              </label>
            </div>
            <div className="reserve-option__content-notes">
              <p>{item.description}</p>
            </div>
          </div>
        </div>
      );
    });
    return rows;
  }

  renderOptionFoods(room) {
    let rows = [];
    room.option_foods.forEach((item, index)=>{
      const id = sprintf("reserve-option-food__checkbox%s", item.id);
      const style = item.countable ? {} : {display: "none"};
      if (!this.state.optionFoods[item.id]) {
        this.state.optionFoods[item.id] = {};
        this.state.optionFoods[item.id].checked = false;
        this.state.optionFoods[item.id].value = 1;
      }
      const amount = this.state.optionFoods[item.id].value;
      const checked = this.state.optionFoods[item.id].checked;
      const plusClass = item.max_count && amount >= item.max_count ? "plus-disabled" : "plus";
      const minusClass = amount > 1 ? "minus" : "minus-disabled";
      rows.push(
        <div key={item.id} className="reserve-card__inner clearfix">
          <div className="reserve-option__content">
            <div style={style} className="reserve-option__number">
              <div className="reserve-stay__line-innner-form">
                <p className="reserve-amount">
                  <span className="reserve-amount__number" data-index={index} id={"foods__" + id + "__number"}>{amount}</span>
                  <span className="reserve-amount__number-minus"><a onClick={this.optionFoodsMinusButtonClick.bind(this, item.id, index)} href="#" className={minusClass}>削除</a></span>
                  <span className="reserve-amount__number-plus"><a onClick={this.optionFoodsPlusButtonClick.bind(this, item.id, item, index)} href="#" className={plusClass}>追加</a></span>
                </p>
              </div>
            </div>
            <div className="reserve-option__content-headline">
              <input checked={checked} onChange={this.optionFoodDidSelect.bind(this, index)} type="checkbox" id={id} name="reserve-option__service" defaultChecked={false} />
              <label htmlFor={id} className="service-checkbox">
                <span className="reserve-option__name">{item.name}</span><span className="reserve-option__price">{item.price_text}<span className="reserve-option__price-number">/{item.price_unit_text}</span></span>
              </label>
            </div>
            <div className="reserve-option__content-notes">
              <p>{item.description}</p>
            </div>
          </div>
        </div>
      );
    });
    return rows;
  }

  renderPriceType(room) {
    const plan = this.state.plan;
    const planId = SMPlanHelper.isRoom(plan) ? 0 : plan.id;
    let rows = [];
    if (plan.has_stay_price) {
      const id = sprintf("reserve-type__radio--stay-%s", planId);
      rows.push(
        <p key={id} className="reserve-type__button">
          <input onChange={this.priceTypeDidSelect.bind(this)} checked={true} id={id} type="radio" name="is_hourly" value={0} className="reserve-type__button-radio" />
          <label htmlFor={id} className="reserve-type__button-label">{I18n.t("service.label_000400")}<span className="reserve-type__price">{plan.stay_price_text}/{plan.stay_price_unit_text}〜</span></label>
        </p>
      );
    } else if (plan.has_session_price) {
      const id = sprintf("reserve-type__radio--session-%s", planId);
      const isHourly = plan.min_required_session_hour_unit == SMConst.RequiredUnit.Hour ? 1 : 0;

      rows.push(
        <p key={id} className="reserve-type__button">
          <input onChange={this.priceTypeDidSelect.bind(this)} checked={true} id={id} type="radio" name="is_hourly" value={isHourly} className="reserve-type__button-radio" />
          <label htmlFor={id} className="reserve-type__button-label">回ごと価格<span className="reserve-type__price">{plan.session_price_text}/{plan.session_price_unit_text}〜</span></label>
        </p>
      );
    } else {
      if (plan.has_hourly_price) {
        const id = sprintf("reserve-type__radio--hourly-%s", planId);
        rows.push(
          <p key={id} className="reserve-type__button">
            <input onChange={this.priceTypeDidSelect.bind(this)} checked={this.state.isHourly == true} id={id} type="radio" name="is_hourly" value={1} className="reserve-type__button-radio" />
            <label htmlFor={id} className="reserve-type__button-label">時間価格<span className="reserve-type__price">{plan.hourly_price_text}/{plan.hourly_price_unit_text}〜</span></label>
          </p>
        );
      }
      if (plan.has_daily_price) {
        const id = sprintf("reserve-type__radio--daily-%s", planId);
        rows.push(
          <p key={id} className="reserve-type__button">
            <input onChange={this.priceTypeDidSelect.bind(this)} checked={this.state.isHourly == false} id={id} type="radio" name="is_hourly" value={0} className="reserve-type__button-radio" />
            <label htmlFor={id} className="reserve-type__button-label">1日価格<span className="reserve-type__price">{plan.daily_price_text}/{plan.daily_price_unit_text}〜</span></label>
          </p>
        );
      }
    }
    return(
      <div ref="priceTypeContainer" key="price_type" className="reserve-next">
        <fieldset>
          <legend className="reserve-subtitle">利用タイプを選択</legend>
          <div className="reserve-card sm-hide__guteter">
            <div className="reserve-card__inner reserve-type clearfix">
              {rows}
            </div>
          </div>
          <input type="hidden" name="rent_type" value={this.state.rentType} />
        </fieldset>
      </div>
    );
  }

  renderSelectSchedules(room) {
    let calendarRows = [];
    if (this.isStayPlan()) {
      calendarRows.push(
        <SMStayReservationCalendarDesktopView
          key="stay"
          delegate={this}
          room={room}
          reservation={this.requestParams}
          plan={this.state.plan}
          isHourly={this.state.isHourly}
           />
       );
    } else {
      calendarRows.push(
        <SMReservationCalendarDesktopView
          key="normal"
          delegate={this}
          room={room}
          reservation={this.requestParams}
          plan={this.state.plan}
          isHourly={this.state.isHourly}
           />
       );
    }

    return(
      <div ref="scheduleContainer" key="schedules" className="reserve-next">
        <fieldset>
          <legend className="reserve-subtitle">利用期間</legend>
          {calendarRows}
        </fieldset>
      </div>
    );

  }

  guestsMinusButtonClick(e) {
    e.preventDefault();
    let num = this.state.numberOfGuests;
    if (num <= 1) {
      return false;
    }
    num -= 1;
    this.setState({
      numberOfGuests: num
    });
    this.requestParams.number_of_guests = num;

    this.validateReservation();
  }

  guestsPlusButtonClick(e) {
    e.preventDefault();
    let num = this.state.numberOfGuests;
    let capacity = this.isDayTimePlan() ? this.props.room.capacity : this.props.room.stay_capacity;
    if (num >= capacity) {
      return false;
    }
    num += 1;
    this.setState({
      numberOfGuests: num
    });
    this.requestParams.number_of_guests = num;

    this.validateReservation();
  }

  renderNumberOfGuests() {
    let priceText = "";
    if (this.isStayPlan()) {
      priceText = this.state.plan.stay_price_text;
    } else if (this.state.plan.has_session_price) {
      priceText = this.state.plan.session_price_text;
    } else {
      if (this.state.isHourly == "1") {
        priceText = this.state.plan.hourly_price_text;
      } else {
        priceText = this.state.plan.daily_price_text;
      }
    }
    let perPersonLabel = this.isPerPersonPlan() ?
      <span className="reserve-stay__checkin-time">利用人数ごとに料金が加算されます ({priceText}/人)</span> : "";

    const num = this.state.numberOfGuests;
    const capacity = this.isDayTimePlan() ? this.props.room.capacity : this.props.room.stay_capacity;
    const plusClass = capacity && num >= capacity ? "plus-disabled" : "plus";
    const minusClass = num > 1 ? "minus" : "minus-disabled";

    return (
      <div className="reserve-stay__line-innner">
        <label>
          <span className="reserve-stay__line-innner-title">利用人数</span>
        </label>
        <div className="reserve-stay__line-innner-form">
          <p className="reserve-amount">
            <span className="reserve-amount__number">{num}</span>
            <span className="reserve-amount__number-minus"><a onClick={this.guestsMinusButtonClick.bind(this)} href="#" className={minusClass}>削除</a></span>
            <span className="reserve-amount__number-plus"><a onClick={this.guestsPlusButtonClick.bind(this)} href="#" className={plusClass}>追加</a></span>
          </p>
        </div>
        {perPersonLabel}
      </div>
    );
  }

  renderCheckinAt() {
    let checkinAtDate = new Date(this.requestParams.reserved_schedules[0]["started_at"]);
    let checkinStartHour = this.state.checkinEnable;

    let checkinEndHour =  this.state.plan.has_extra_stay_checkinout_hour ?
      this.state.plan.extra_stay_checkin_end_hour : this.props.room.stay_checkin_end_hour;

    let checkinAtRows = [];
    for (let i = checkinStartHour; i <= checkinEndHour; i++) {
      let hour = i;
      let checkinTimeZero = i.toString() + ":00";
      let checkinTimeHalf = i.toString() + ":30";
      if (i == checkinStartHour) {
        checkinAtRows.push(<option value={checkinTimeZero} defaultValue={checkinTimeZero} selected>{checkinTimeZero}</option>);
        checkinAtRows.push(<option value={checkinTimeHalf}>{checkinTimeHalf}</option>);
      } else {
        checkinAtRows.push(<option value={checkinTimeZero}>{checkinTimeZero}</option>);
        if (i == checkinEndHour) {
          break;
        } else {
          checkinAtRows.push(<option value={checkinTimeHalf}>{checkinTimeHalf}</option>);
        }
      }
    }

    return (
      <div className="reserve-stay__line-innner">
        <label>
          <span className="reserve-stay__line-innner-title">チェックイン時刻</span>
          <span className="reserve-stay__line-innner-form">
            <span className="service-select">
              <select onChange={this.checkinAtDidSelect.bind(this)} name="checkin_at" id="checkin_at" className="service-select__purpose w110">
                {checkinAtRows}
              </select>
            </span>
         </span>
        </label>
        <span className="reserve-stay__checkin-time">チェックイン可能時刻：{checkinStartHour.toString() + ":00～" + checkinEndHour.toString() + ":00"}</span>
      </div>
    );
  }

  renderStayGuestInfo() {
    return (
      <div key="stay_guest_info" className="reserve-next">
        <fieldset>
          <legend className="reserve-subtitle">宿泊者情報</legend>
            <div className="reserve-card sm-hide__guteter">
              <div className="reserve-card__inner clearfix">
                <div className="reserve-stay__line">
                  {this.renderNumberOfGuests()}
                  {this.renderCheckinAt()}
                </div>
              </div>
            </div>
        </fieldset>
      </div>
    );
  }

  renderGuestInfo() {
    return (
      <div key="guest_info" className="reserve-next">
        <fieldset>
          <legend className="reserve-subtitle">ゲスト情報</legend>
            <div className="reserve-card sm-hide__guteter">
              <div className="reserve-card__inner clearfix">
                <div className="reserve-stay__line">
                  {this.renderNumberOfGuests()}
                </div>
              </div>
            </div>
        </fieldset>
      </div>
    );
  }

  renderSelectOptions(room) {
    return(
      <div key="options" className="reserve-next">
        <fieldset>
          <legend className="reserve-subtitle">追加料金（オプション）</legend>
          <div className="reserve-card sm-hide__guteter">
            <h2 style={SMRenderHelper.hideIfEmpty(room.option_items)} className="reserve-option__headline">設備・サービス</h2>
            {this.renderOptionItems(room)}
            <h2 style={SMRenderHelper.hideIfEmpty(room.option_foods)} className="reserve-option__headline">飲食</h2>
            {this.renderOptionFoods(room)}
          </div>
        </fieldset>
      </div>
    );
  }

  renderResult(room) {
    let mobileRows = [];

    if (this.state.validatedReservation && this.state.validatedReservation.is_last_minute_discount_warning) {
      mobileRows.push(
        <p key="last_minute_discount" className="reserve-payment__notify-info-time"><i className="fa fa-exclamation-circle"></i>直前割期間対象外の利用期間が存在するため、直前割は適用されません。</p>
      );
    }

    if (!this.state.isValid) {
      if (this.state.errors.length > 0) {
        this.state.errors.forEach((error, index)=>{
          mobileRows.push(
            <p key={index} className="reserve-payment__notify-info-time"><i className="fa fa-exclamation-circle"></i>{error.message}</p>
          );
        });
      } else {
        if (!this.state.plan) {
          mobileRows.push(
            <p key="info" className="reserve-payment__notify-info-time">プランを選択してください</p>
          );
        } else {
          if (!this.state.validatedReservation) {
            mobileRows.push(
              <p key="info" className="reserve-payment__notify-info-time">利用期間を選択してください</p>
            );
          }
          if (SMPlanHelper.shoudRenderMinRequiredDate(this.state.plan)) {
            mobileRows.push(
              <p key="min_hour" className="reserve-payment__notify-info-time">最低利用日数は<strong>{this.state.plan.min_required_hour}日間</strong>です。</p>
            );
          } else if (SMPlanHelper.shouldRenderMinRequiredTime(this.state.plan)) {
            mobileRows.push(
              <p key="min_hour" className="reserve-payment__notify-info-time">最低利用時間は<strong>{this.state.plan.min_required_hour}時間</strong>です。</p>
            );
          }
          if (SMPlanHelper.shouldRenderRequiredFood(this.state.plan)) {
            mobileRows.push(
              <p key="food" className="reserve-payment__notify-info-time">このプランは飲食が<strong>必須</strong>です。</p>
            );
          }
        }
      }
    }

    return(
      <div className="reserve-payment__notify">
        <div className="reserve-payment__notify-info">
          <p className="reserve-payment__notify-info-payment">合計：{this.state.priceText}(税抜)</p>
          {mobileRows}
        </div>
      </div>
    );
  }

  validateReservation() {
    this.setState({display: SMConst.Display.Loading});
    $(".js-reservation-submit-card").stopLoading().startLoading();
    SMRoomResource.validateReservation(this.state.room.id, this.requestParams, (reservation, error, xhr)=>{
      this.setState({display: SMConst.Display.Visible});
      $(".js-reservation-submit-card").stopLoading();
      if(!error) {
        this.setState({
          priceText: reservation.billing.total_amount_with_last_minute_discount_except_tax_text,
          priceExtraText: sprintf(I18n.t("service.label_000023"), reservation.billing.guest_total_amount_with_tax_text),
          reservedDateText: reservation.reserved_date_text,
          validatedReservation: reservation,
          isValid: reservation.is_available,
        });
      } else {
        this.setState({errors: xhr.responseJSON.errors});
      }

      if (window.AndroidJavascriptBridge) {
        // Androidはprimitiveな型しか許さない
        window.AndroidJavascriptBridge.send(JSON.stringify(reservation));
      } else {
        this.appBridge.send(reservation, function(responseData) {
          // alert('objCにデータを送信完了');
        });
      }
    });

  }

  render() {

    const room = this.state.room;

    let stepRows = [];
    if (this.state.plan) {
      stepRows.push(this.renderPriceType(room));
      if (this.state.isHourly != null) {
        stepRows.push(this.renderSelectSchedules(room));
        if (this.isStayPlan() && this.requestParams.stay_checkin_at && this.requestParams.stay_checkout_at) {
          stepRows.push(this.renderStayGuestInfo());
        } else if (this.isDayTimePlan() && this.isPerPersonPlan()) {
          stepRows.push(this.renderGuestInfo());
        }
        if (room.option_items.length > 0 || room.option_foods.length > 0) {
          stepRows.push(this.renderSelectOptions(room));
        }
      }
    }

    return(
      <div className="site-main-app">
        <div className="page__even page__padding">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <legend className="reserve-subtitle">プランを選択</legend>
                  {this.renderPlans(room)}
                </fieldset>

                <CSSTransitionGroup transitionName="js-list-fade-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
                  {stepRows}
                </CSSTransitionGroup>

                {this.renderResult(room)}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}
export default SMAppReservationView;



// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMAppReservationView.jsx